import { TranslateService } from "../shared/util/translate.service";
import { AreaSelectionState } from "./area-selection.state";

export const selectAreas = (state: AreaSelectionState) => state.areas;

export const selectSelectedAreaId = (state: AreaSelectionState) => state.selectedAreaId;

export const selectSelectedArea = (state: AreaSelectionState) => {
  if (state.selectedAreaId === null) {
    return null; // Represents "all"
  }
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  return state.areas.find(area => area.areaId === state.selectedAreaId) || null;
};

export const selectAreaLoading = (state: AreaSelectionState) => state.loading;

export const selectAreaOptions = (state: AreaSelectionState, translateService: TranslateService) => [
  // the all value is the join of all areas ids separated by comma
  // { value: state.areas.map(area => area.areaId).join(','), label: translateService.instant('generic.all_areas') }, 
  { value: null, label: translateService.instant("generic.all_areas") }, 
  ...state.areas.map(area => ({ value: area.areaId, label: area.name }))
]; 